import { OVERLAY_MOTION } from './motion/overlayMotionTokens';

/**
 * Keyframes for the mobile bottom action sheet (ActionMenu's isMobile path).
 * Extracted from ActionMenu.js (500-line cap). Named with the "action-sheet-"
 * prefix to avoid collision with the anchored-menu keyframes
 * (ANCHORED_MENU_KEYFRAMES_CSS).
 *
 * Reduced motion: enter/exit collapse to opacity-only (no slide).
 */
export const ACTION_SHEET_KEYFRAMES_CSS = `
  @keyframes crewvex-action-sheet-slide-in {
    from { transform: translateY(100%); }
    to   { transform: translateY(0); }
  }
  @keyframes crewvex-action-sheet-slide-out {
    from { transform: translateY(0); }
    to   { transform: translateY(100%); }
  }
  @keyframes crewvex-action-sheet-scrim-in {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  @keyframes crewvex-action-sheet-scrim-out {
    from { opacity: 1; }
    to   { opacity: 0; }
  }
  @media (prefers-reduced-motion: reduce) {
    @keyframes crewvex-action-sheet-slide-in {
      from { opacity: 0; }
      to   { opacity: 1; }
    }
    @keyframes crewvex-action-sheet-slide-out {
      from { opacity: 1; }
      to   { opacity: 0; }
    }
  }
`;

/** Animation shorthand for the sheet scrim / panel (enter or exit), from the overlay motion family. */
export const actionSheetAnimation = (part, isExiting) => (isExiting
  ? `crewvex-action-sheet-${part}-out ${OVERLAY_MOTION.slideExitMs}ms ${OVERLAY_MOTION.easing} forwards`
  : `crewvex-action-sheet-${part}-in ${OVERLAY_MOTION.slideEnterMs}ms ${OVERLAY_MOTION.easing}`);
